const state = {
  isConnected: false,
}

const getters = {}

const actions = {
  connect({ state, dispatch }) {
    if (navigator.onLine === false) {
      dispatch("ws_disconnect")
      return
    }
    if (state.isConnected === true) {
      console.log("already connected to ws")
      dispatch("socket/eventJoin", null, { root: true })
      dispatch("openQuestion")
      return
    }

    this._vm.$socket.live.connect()
  },

  disconnect() {
    this._vm.$socket.live.disconnect()
  },

  openQuestion({ rootState, commit }) {
    // 081ee857-BRAINSTORMING-S1-STAN-b939c19b3ce3 => old brainstorm 'Comment identifier le besoin'
    // C250AFF4-7617-4583-A7A6-DA2C65BDBEC1 => new brainstorm 240-17 'Maxime quos fugiat voluptatem autem ut.'
    this._vm.$socket.live.emit("question:info", null, (question) => {
      if (rootState.live.refresh === true || question === null || question.guid !== rootState.question.guid_text) {
        this._vm.$socket.live.emit("question:open", { guid: rootState.question.guid_text, refresh: true })
        return
      }
      commit(
        "answers/addAnswerFromSocket",
        { results: question.responses, question_guid: question.guid },
        { root: true }
      )
    })
  },

  startTimer({ rootState }, duration) {
    this._vm.$socket.live.emit("question:timer:start", { guid: rootState.question.guid_text, delay: duration })
  },

  hideQuestion({ rootState }) {
    this._vm.$socket.live.emit("question:hide", { guid: rootState.question.guid_text })
    this._vm.$socket.live.disconnect()
  },

  pushLabel({ rootState }, label) {
    if (rootState.live.isActive) {
      this._vm.$socket.live.emit("question:label:add", { label: label })
    }
  },

  pushAnswer({ rootState }, { questionGuid, responseTextWithLabelGuid }) {
    if (rootState.live.isActive) {
      this._vm.$socket.live.emit("question:response:post", {
        guid: questionGuid,
        response: responseTextWithLabelGuid,
      })
    }
  },

  deleteAnswers({ rootState }, { guids }) {
    if (rootState.live.isActive) {
      this._vm.$socket.live.emit("question:response:delete", { guids: guids })
    }
  },

  editLabel({ rootState }, label) {
    if (rootState.live.isActive) {
      this._vm.$socket.live.emit("question:label:edit", { label: label })
    }
  },

  deleteLabel({ rootState }, { guid, newGuid }) {
    if (rootState.live.isActive) {
      this._vm.$socket.live.emit("question:label:delete", { guid: guid, newGuid: newGuid })
    }
  },

  associateLabel({ rootState }, { answerGuids, labelGuid }) {
    if (rootState.live.isActive) {
      this._vm.$socket.live.emit("question:response:label", { answerGuids: answerGuids, labelGuid: labelGuid })
    }
  },

  ws_connect({ commit, rootState, dispatch }) {
    commit("setIsConnected", true)
    this.commit("app/setIsOffline", false)
    dispatch("eventJoin")
  },

  eventJoin({ rootState, dispatch }) {
    let token = rootState.pilot.accessToken
    let event_guid = rootState.pilot.event_guid
    let user_guid = rootState.pilot.user.guid_text

    this._vm.$socket.live.emit("event:join", { token, event_guid, user_guid }, (isLoggued) => {
      console.log("has joined event ", event_guid)
      dispatch("openQuestion")
    })
  },

  ws_disconnect({ commit }) {
    commit("setIsConnected", false)
    this.commit("app/setIsOffline", true)
  },

  "ws_questionv2:response:result"({ commit, rootState }, { question_guid, responses }) {
    commit("answers/addAnswerFromSocket", { results: responses, question_guid: question_guid }, { root: true })
  },

  "ws_question:attendees"({ commit, rootState }, { attendees }) {
    if (rootState.question.attendees !== attendees) {
      commit("question/setAttendees", attendees, { root: true })
    }
  },

  "ws_question:connected"({ commit, rootState }, { connected }) {
    if (rootState.question.connected !== connected) {
      commit("question/setConnected", connected, { root: true })
    }
  },

  "ws_users:alive"({ commit, rootState }, { usersAlive }) {
    if (rootState.question.connected !== usersAlive) {
      commit("question/setConnected", usersAlive, { root: true })
    }
  },
}

const mutations = {
  setIsConnected(state, value) {
    state.isConnected = value
    if (value === true) {
      console.log("connected to ws")
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
